import React, {useEffect, useLayoutEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import Product from '../Models/ProductModels'
import productsData from "../JSON/products.json"
import Color from '../Components/Colors/Color'
import Header from '../Models/HeaderContainer'
import "../Styles/ProductsPage.css"
import ClipLoader from "react-spinners/ClipLoader"
import "../Admin/Components/Overlay/Overlay.css"
import { useStateContext } from '../Contexts/productsCardContext'
import { fetchProducts } from '../Admin/Controller/ProductController'

const ProductsPage = () => {

  const [filteredProducts, setFilteredProducts] = useState(productsData.products);
  const [flag, setFlag] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPage('other');
    window.scrollTo(0, 0);

  }, [flag])

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const navigate = useNavigate();

  const {setPage} = useStateContext();

  const [searchValue, setSearchValue] = useState("");
  const [searchValueIsEmpty, setSearchValueIsEmpty] = useState(true);

  const handleSearchChange = (e) => {
    const searchValueChange = e.target.value;

    setSearchValue((prevValue) => {
      const newValue = searchValueChange;
      if (newValue !== "") {
        setSearchValueIsEmpty(false);
      } else {
        setSearchValueIsEmpty(true);
      }
      return newValue;
    });
  }

 

  const handleErase = () =>{
    setSearchValue("");
    setSearchValueIsEmpty(true);
    // setFilteredProducts(productsData.products);
  }

  const handleSearch = (e) => {
    console.log(searchValue);
    e.preventDefault();
    // if(!searchValue) return;
    setFlag( f => !f)

    // const filtered = productsData.products.filter((product) =>
    //   product.name.toLowerCase().includes(searchValue.toLowerCase())
    // );
    

    const filtered = productsData.products.filter((product) => {
      const productNameMatches = product.name.toLowerCase().includes(searchValue.toLowerCase());
    
      if (productNameMatches) {
        return true; // If product name matches, include the product in the filtered array
      }
    
      // If product name doesn't match, check if any item in the list matches the search value
      if (product.list) {
        for (const item of product.list) {
          if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
            return true; // If any item matches, include the product in the filtered array
          }
        }
      }
    
      return false; // If neither product name nor any item in the list matches, exclude the product
    });

    setFilteredProducts(filtered)

  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch(e);
      e.target.blur();
    }
  }

  const handleClear = () => {
    handleErase();
    setFilteredProducts(productsData.products);
    setFlag( f => !f)
  }

  const handleMoveToProductDetails = (id) =>{
    navigate(`./detail?id=${id}`)
  }

  // const filteredProducts = productsData.products.filter((product) =>
  //   product.name.toLowerCase().includes(searchValue.toLowerCase())
  // );

  useEffect(() => {
        
    const handleFetchProducts = async () => {
        try{
            setLoading(true);
            const response = await fetchProducts();
            const productList = response.data.products;
            const sortedProducts = productList.sort((a, b) => a.name.localeCompare(b.name));
            setProducts(sortedProducts || [])

        }catch(error)  {
            console.log(error?.response?.data?.message || "An error occurred");
        }finally{
          setLoading(false);
        }
    }
    
    handleFetchProducts();
},[])

  return (
    <div className='products-page-container' style={{backgroundColor:Color.primaryBackground, color: Color.secondaryText}}>
      {/* <div className='products-page-header-container'>
        <img src='/Images/products-page-bg.png' alt='product-header-img' className='products-header-img' />
        <img src='/Images/products-header-bg-small.png' alt='product-header-img' className='products-header-img-small' />
        <img src='/Images/products-header-bg-micro.png' alt='product-header-img' className='products-header-img-micro' />
        <h1 className='products-page-header'>Products</h1>
      </div> */}
      <Header name="Products"/>
      <div className='products-page-search-container'>
        <input 
          type='text' 
          placeholder='Search...'
          className='products-page-search-input' 
          onChange={(e) => handleSearchChange(e)}
          value={searchValue}
          onKeyPress={handleKeyPress}
          id='search-bar'
          style={{color: Color.thirdText}}
        />
        <span className='fa-solid fa-magnifying-glass products-page-search-icon' onClick={handleSearch}></span>
        <span className={`${searchValueIsEmpty ? "" : "fa-solid fa-xmark xmark-search"}`} onClick={handleErase}></span>
        <span className='products-page-clear-btn' onClick={handleClear}>Clear Search</span>
      </div>

      <div className='products-page-content-container'>
        <div className={`products-list-container ${filteredProducts.length ? 'grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 place-items-center gap-10 xl:gap-20 mb-6 ' : ''} `}>
          {products.length ? products.map((product) => {
            return(
              <div className='products-page-card' onClick={() => handleMoveToProductDetails(product.id)} key = {product.id}>
                <Product product = {product}/>
              </div>
            )
          }) : !loading && <h4 className='products-page-empty-header' style={{color: Color.thirdText}}>No products found with this keyword. <br/>Please search for another product.</h4>}
        </div>

        <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
            <ClipLoader size={100} color='black' />
        </div>
      </div>
    </div>
  )
}

export default ProductsPage